declare global {
  interface Window {
    __NIRA_PUBLIC_CONFIG__?: {
      REACT_APP_BASE_URL?: string;
      /** Runtime override for live Nira WebSocket progress (Docker / k8s without rebuild). */
      REACT_APP_ARIA_WS_PROGRESS?: string;
    };
  }
}

/**
 * API origin: runtime file (Docker) first, then build-time env (Vite define).
 * Use for axios baseURL and Nira WebSocket URL so they stay aligned.
 */
export function getPublicApiBaseUrl(): string | undefined {
  if (typeof window !== "undefined") {
    const fromRuntime = window.__NIRA_PUBLIC_CONFIG__?.REACT_APP_BASE_URL?.trim();
    if (fromRuntime) {
      return fromRuntime.replace(/\/$/, "");
    }
  }
  const fromEnv = process.env.REACT_APP_BASE_URL?.trim();
  if (fromEnv) {
    return fromEnv.replace(/\/$/, "");
  }
  return undefined;
}
